import React, { useState } from 'react'
import { Box, Paper, Typography } from '@material-ui/core'
import { useHistory, generatePath } from 'react-router-dom'
import { useQuery, useMutation, queryCache } from 'react-query'
import { useSnackbar } from 'notistack'
import Button from 'UI/Button/ButtonWithPreloader'
import ModalComponent from 'UI/Modal'
import ConfirmationContent from 'UI/Modal/ConfirmationContent'
import { TableChangeLogEntries, useChangeLogEntries } from 'hooks/useChangeLogEntries'
import { getChangeLogEntries, deleteChangeLogEntry } from 'services/changeLog'
import { IChangeLogListItem } from 'typescript/interfaces/changeLog'
import { CHANGE_LOG_EDIT_URL, CHANGE_LOG_NEW_URL } from 'constants/routes'
import { SOMETHING_WENT_WRONG } from 'constants/errors'
import { useAdditionalMaterialStyle } from 'containers/MaterialUiContainer/additionalStyles'

const ChangeLogManage = () => {
  const additionalStyle = useAdditionalMaterialStyle()
  const history = useHistory()
  const { enqueueSnackbar } = useSnackbar()
  const [entryToDelete, setEntryToDelete] = useState<IChangeLogListItem | null>(null)

  const { data, isLoading } = useQuery('changelog-entries', getChangeLogEntries)

  const [deleteEntryMut, { isLoading: isDeleting }] = useMutation(deleteChangeLogEntry, {
    onSuccess: () => {
      queryCache.invalidateQueries('changelog-entries')
      queryCache.invalidateQueries('changelog-history')
      setEntryToDelete(null)
      enqueueSnackbar('Change log entry successfully deleted')
    },
    onError: () => enqueueSnackbar(SOMETHING_WENT_WRONG),
  })

  const { columns } = useChangeLogEntries({
    handleEdit: (entry: IChangeLogListItem) => history.push(generatePath(CHANGE_LOG_EDIT_URL, { id: entry.id })),
    handleDelete: (entry: IChangeLogListItem) => setEntryToDelete(entry),
  })

  return (
    <Box className={additionalStyle.wrapper} component={Paper} mb="2rem">
      <Box p="3rem" pb="2rem" display="flex" alignItems="center" justifyContent="space-between">
        <Typography variant="h2" color="textSecondary">
          What&apos;s New Entries
        </Typography>
        <Button color="primary" variant="contained" onClick={() => history.push(CHANGE_LOG_NEW_URL)}>
          Add Entry
        </Button>
      </Box>
      <Box>
        <TableChangeLogEntries loading={isLoading} data={data ? data.data : []} columns={columns} />
      </Box>
      <ModalComponent open={Boolean(entryToDelete)}>
        <ConfirmationContent
          isLoading={isDeleting}
          renderedElement={<span>{`Are you sure you want to delete ${entryToDelete ? entryToDelete.name : ''}?`}</span>}
          confirmText="Yes"
          cancelText="No"
          handleCancel={() => setEntryToDelete(null)}
          handleConfirm={() => entryToDelete && deleteEntryMut(entryToDelete.id)}
        />
      </ModalComponent>
    </Box>
  )
}

export default ChangeLogManage
